import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { forwardRef, ReactElement, Ref, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  GET_SESSION_TIME_OUT,
  LOG_OUT,
} from "../../redux/reducers/loginReducer";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function SessionTimeOut() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const session = useSelector((state: any) => state.session);
  const settings = useSelector((state: any) => state.settings.internalSettings);
  const [timeLeft, setTimeLeft] = useState(60);
  const minuteInMillis = 1000 * 60;

  useEffect(() => {
    if (open) {
      const intervalId = setInterval(() => {
        setTimeLeft((t) => t - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [open, session?.sessionTimeout]);

  useEffect(() => {
    if (timeLeft <= 0) {
      handleClose();
    }
  }, [timeLeft]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (session?.currentUser && settings?.serverURL) {
      dispatch({ type: GET_SESSION_TIME_OUT });
    }
  }, [dispatch, session?.currentUser]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (session?.sessionTimeout) {
      const timer = setTimeout(() => {
        if (getPreTimeout() < minuteInMillis * 5) {
          setOpen(true);
          const timeOut = Math.floor(getPreTimeout() / 1000);
          setTimeLeft(timeOut > 30 ? 30 : timeOut - 10);
        } else {
          dispatch({ type: GET_SESSION_TIME_OUT });
        }
      }, getPreTimeout() / 2);

      return () => clearTimeout(timer);
    }
  }, [session?.sessionTimeout]); //eslint-disable-line react-hooks/exhaustive-deps

  function handleLogin() {
    setOpen(false);
    dispatch({ type: LOG_OUT, payload: {} });
    navigate("/login");
  }

  function handleClose() {
    setOpen(false);
    navigate("/logout");
  }

  function getPreTimeout() {
    const timeOut =
      new Date(session?.sessionTimeout).getTime() - new Date().getTime();

    const minutes = minuteInMillis * 20;
    return timeOut > minutes ? minutes : timeOut;
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{t("sessionTimeOut.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t("sessionTimeOut.message")} {timeLeft}{" "}
            {timeLeft > 1 ? t("seconds") : t("second")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogin}>{t("sessionTimeOut.newLogin")}</Button>
          <Button onClick={handleClose}>{t("titles.help.logout")}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
